import { Component } from "react"

class DisplayId extends Component{
    constructor(props){
        super(props)
        this.name = "表示ID"
    }
    validate(callbackDialog,required){
        if(required && String(this.props).trim().length === 0){
            //callbackDialog("エラー",this.name + "は必須です。")
            //return false
        }
        if(this.props.length > 0 && !/^[0-9a-zA-Z_]{3,20}$/i.test(this.props)){
            callbackDialog("エラー",this.name + "は3文字以上20文字以内にしてください。")
            return false
        }
        return true
    }
}

export default DisplayId;